export function WelcomeScreen({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  return (
    <div className="cuadra-flex cuadra-flex-col cuadra-items-center cuadra-text-center cuadra-py-6">
      <h2
        className="cuadra-text-2xl md:cuadra-text-4xl cuadra-font-normal cuadra-text-foreground/80 cuadra-tracking-tight"
        style={{
          fontFamily:
            "var(--cuadra-font-logo), Outfit, -apple-system, sans-serif",
        }}
      >
        {title}
      </h2>
      {subtitle && (
        <p className="cuadra-text-sm md:cuadra-text-base cuadra-text-muted-foreground cuadra-mt-2 md:cuadra-mt-3 cuadra-max-w-lg cuadra-whitespace-pre-line">
          {subtitle}
        </p>
      )}
    </div>
  );
}
